// extracted by mini-css-extract-plugin
export default {"active_tab":"styles_active_tab__tdCR+","button":"styles_button__ARIEW"};